import { useMutation } from '@tanstack/react-query';

import { Agents } from '@air/api';
import { callAirApi } from '@air/utils-api';

export type UsePrivateWorkspaceAgentSessionStartMutationParams = NonNullable<
  Parameters<typeof Agents.Sessions.start>[0]
>;

export const usePrivateWorkspaceAgentSessionStartMutation = () =>
  useMutation({
    mutationFn: async (params: UsePrivateWorkspaceAgentSessionStartMutationParams) =>
      callAirApi(() => Agents.Sessions.start(params)),
  });
